import { render } from "./LinesROI.vue?vue&type=template&id=bc0a6b42&ts=true"
import script from "./LinesROI.vue?vue&type=script&lang=ts"
export * from "./LinesROI.vue?vue&type=script&lang=ts"

import "./LinesROI.vue?vue&type=style&index=0&id=bc0a6b42&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__